import { useEffect, useState } from 'react';
import { useMagpieTopic } from './useMagpieTopic';
import { AssistantTopicDef } from '../topics/assistantTopics';
import { assistantPublishMessage } from '../messages/assistantPublishMesage';
/**
 * Hook to subscribe to assistant streaming status changes.
 *
 * @returns Object containing current streaming status
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const { isAssistantBusy } = useIsAssistantBusy();
 *
 *   return (
 *     <div>
 *       {isAssistantBusy ? 'AI is thinking...' : 'AI is ready'}
 *     </div>
 *   );
 * }
 * ```
 */

export const useIsAssistantBusy = () => {
  // Subscribe to the assistant topic
  const {
    topic: assistantTopic,
    subscribe,
    isSubscribed
  } = useMagpieTopic(AssistantTopicDef);

  // State to store the  assistant streaming status
  const [isAssistantBusy, setIsAssistantBusy] = useState(false);
  useEffect(() => {
    if (!assistantTopic) {
      return;
    }

    // Subscribe to the topic if not already subscribed
    if (!isSubscribed) {
      subscribe();
    }
    const onAssistantMessage = message => {
      setIsAssistantBusy(message.payload.isAssistantBusy);
    };
    const unsubscribe = assistantTopic.on(assistantPublishMessage.getType(), onAssistantMessage);
    return () => {
      unsubscribe();
    };
  }, [assistantTopic, subscribe, isSubscribed]);
  return {
    isAssistantBusy
  };
};